<div class="modal fade" bsModal #modalRef="bs-modal" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-right-full" role="document">
    <div class="modal-content">
      <div class="modal-body" #modalBody>
        <div class="issue-wrapper">
          <div class="header-row">
            <h1>Issue Details</h1>
            <img (click)="closeModal()" src="assets/img/x.svg" class="icon" alt="" />
          </div>
          <div class="accordion-wrapper">
            <span class="show-flag-changelog">Flag-level Changelog ({{ groupChanges?.length }})</span>

            <div class="flag-level-accordion-body" #flagLevelBody>
              <div class="flag-accordion-list">
                <div
                  class="flag-accordion-item"
                  *ngFor="let flag of filteredFlags; let i = index; trackBy: trackByIndex"
                  #flagItem>
                  <div
                    class="flag-level-accordion-header"
                    [class.disabled]="flag?.changes?.length === 0"
                    (click)="toggleFlagAccordion(i)"
                    [ngStyle]="{ 'background-color': openGroupFlags[i] ? '#EEF3FB' : 'transparent' }">
                    <span>{{ flag?.label }} / {{ flag?.question }}</span>
                    <img
                      src="assets/img/svg/chevron-down-black.svg"
                      class="icon chevron"
                      [class.rotate]="openGroupFlags[i]" />
                  </div>
                  <div *ngIf="openGroupFlags[i]">
                    <ng-container *ngTemplateOutlet="flagTimeline; context: { $implicit: flag }"></ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #flagTimeline let-flag>
  <div *ngFor="let c of flag.changes; let i = index; let last = last" class="timeline-entry">
    <div class="timeline-left">
      <div class="timeline-icon-wrapper">
        <img src="assets/img/svg/pencil.svg" alt="edit" />
      </div>
      <div class="timeline-line" [ngClass]="{ 'extended-line': !last, 'short-line': last }"></div>
    </div>

    <div class="timeline-content">
      <p class="entry-header">
        <span class="username">{{ c.username }}</span>
        <span *ngIf="c.user" class="user-type">
          {{ c.user.type === 'AdminUser' ? 'Admin' : c.user?.type }}
        </span>
        <span class="timestamp">
          <span>{{ c.date | date: 'MM/dd/yyyy h:mm a' }}</span>
        </span>
      </p>

      <div class="change-list">
        <div class="change-card" *ngFor="let change of c.changes | keyvalue">
          <div class="change">
            <span class="dot">•</span>
            <span class="change-title">{{ change.key }}<span *ngIf="change.value">:</span></span>
          </div>

          <div class="change-row" *ngIf="change.value">
            <span class="key">From:</span>
            <span class="change-value" *ngIf="!change.value?.before">empty</span>
            <span
              *ngIf="change.value?.before"
              class="html-output"
              [innerHTML]="getSanitizedValue(change.value?.before)"></span>
          </div>

          <div class="change-row" *ngIf="change.value">
            <span class="key">To:</span>
            <span class="change-value" *ngIf="!change.value?.after">empty</span>
            <span
              *ngIf="change.value?.after"
              class="html-output"
              [innerHTML]="getSanitizedValue(change.value?.after)"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
